import { Component, Input } from '@angular/core';
import { ImageUtils } from '../Services/imageutils';
import { OrderService } from '../Services/order';
import { Order } from '../Models/order';


@Component({
  selector: 'profile-orders',
  templateUrl: '../Templates/profile.orders.html'
})


export class ProfileOrdersComponent {

  @Input()
  public orders: Order[];

  orderdetail: Array<boolean> = [];

  constructor(private orderService: OrderService,
              private imageUtils: ImageUtils,
             ) { }

  ngOnInit() {

    if (this.orders) {
      for (var i = 0; i < this.orders.length; i++) {
        this.orderdetail.push(false);
      }
    }
  }

  public markReceived(order: Order, idx: number) {
    this.orderService.markReceived(order).subscribe(
      data => {
        this.orders[idx] = data;
      }
    );
  }

  toggleOrderDetail(idx: number): void {
    this.orderdetail[idx] = !this.orderdetail[idx];
  }

  showOrderDetail(idx: number): boolean {
    return this.orderdetail[idx];
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/profile.orders.ts